import React, { useState } from 'react';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import AttachmentTools from './AttachmentTools';

const FolderToolsMenu = ({
  allowManage,
  folder,
  category,
  code,
  upward,
}) => {
  const [open, setOpen] = useState(false);
  const {
    canDelete, isLoading, canUpdate, isRoot,
  } = Selectors.useAttachmentToolsMenu({ category, code, attachment: folder });
  const showDeleteDialog = Events.useShowDeleteDatasetFolder(category, { code });
  const supportsUpdate = allowManage && canUpdate && isRoot;

  if (!canDelete) {
    return null;
  }

  return (
    <StandardToolsMenu
      allowDelete={canDelete}
      className="dataset-attachment-tools"
      upward={upward}
      onChange={setOpen}
      onDelete={() => showDeleteDialog({ folder })}
      open={open}
    >
      {open && (
        <AttachmentTools
          attachment={folder}
          canManage={canUpdate}
          canUpdate={supportsUpdate}
          category={category}
          code={code}
          isLoading={isLoading}
        />
      )}
    </StandardToolsMenu>
  );
};

export default FolderToolsMenu;
